var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_27703_62163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 12.1723V14.1723C14.6675 14.358 14.6294 14.5418 14.555 14.7119C14.4807 14.882 14.3716 15.0347 14.2348 15.1602C14.0979 15.2857 13.9364 15.3813 13.7605 15.4408C13.5847 15.5003 13.3983 15.5224 13.2134 15.5057C11.1619 15.2827 9.19137 14.5817 7.46004 13.459C5.84926 12.4354 4.48359 11.0698 3.46004 9.45898C2.33336 7.71979 1.6322 5.73965 1.41337 3.67898C1.39671 3.49463 1.41862 3.30882 1.4777 3.1334C1.53679 2.95798 1.63175 2.79678 1.75655 2.66006C1.88134 2.52335 2.03324 2.41412 2.20256 2.33933C2.37189 2.26454 2.55493 2.22582 2.74004 2.22565H4.74004C5.06357 2.22247 5.37723 2.33704 5.62254 2.54801C5.86786 2.75898 6.02809 3.05195 6.07337 3.37232C6.15779 4.01236 6.31434 4.6408 6.54004 5.24565C6.62973 5.48427 6.64915 5.74359 6.59597 5.9929C6.5428 6.24221 6.41928 6.47106 6.24004 6.65232L5.39337 7.49898C6.34241 9.16801 7.72434 10.5499 9.39337 11.499L10.24 10.6523C10.4213 10.4731 10.6501 10.3496 10.8994 10.2964C11.1488 10.2432 11.4081 10.2626 11.6467 10.3523C12.2516 10.578 12.88 10.7346 13.52 10.819C13.8439 10.8647 14.1396 11.0278 14.3511 11.2773C14.5625 11.5268 14.6748 11.8454 14.6667 12.1723Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27703_62163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.892578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.e7b63c2dc68414b2d5acc822f07696cc.svg";
export { ForwardRef as ReactComponent };